export default [
  {
    name: "D: T3, W2, 4+, x20",
    computed_keywords: [],
    computed_leaders: [],
    computed_model_count: 20,
    computed_roles: ["Defender"],
    computed_toughness: 3,
    computed_wounds: 2,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "becfe536-5fd5-4699-98f6-fb400718e509",
        modelTypeName: null,
        unitId: "10b2d296-bc3f-49ee-8898-8b10e4adf3aa",
      },
    ],
    units: [
      {
        id: "10b2d296-bc3f-49ee-8898-8b10e4adf3aa",
        leader: false,
        name: "D: T3, W2, 4+, x20 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            modelCount: 20,
            save: 4,
            toughness: 3,
            wounds: 2,
            id: "becfe536-5fd5-4699-98f6-fb400718e509",
            name: "D: T3, W2, 4+, x20 > Unit 1 > Model type 1",
            weapons: [],
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [],
  },
  {
    name: "D: Light vehicle",
    computed_keywords: ["VEHICLE"],
    computed_leaders: [],
    computed_model_count: 1,
    computed_roles: ["Defender"],
    computed_toughness: 6,
    computed_wounds: 6,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "9702b3ff-bf02-450c-a6ac-992f629823f7",
        modelTypeName: null,
        unitId: "89ce43cb-07af-41eb-9402-f855aa23beb5",
      },
    ],
    units: [
      {
        id: "89ce43cb-07af-41eb-9402-f855aa23beb5",
        leader: false,
        name: "D: Light vehicle > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            keywords: ["VEHICLE"],
            modelCount: 1,
            save: 4,
            toughness: 6,
            wounds: 6,
            id: "9702b3ff-bf02-450c-a6ac-992f629823f7",
            name: "D: Light vehicle > Unit 1 > Model type 1",
            weapons: [],
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [],
  },
  {
    name: "D: Knight",
    computed_keywords: ["TITANIC", "VEHICLE"],
    computed_leaders: [],
    computed_model_count: 1,
    computed_roles: ["Defender"],
    computed_toughness: 8,
    computed_wounds: 24,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "5554b977-08c1-4e2c-ac99-2ac8ba424726",
        modelTypeName: null,
        unitId: "111af0ec-aa19-48a8-8128-21c40d8c1a14",
      },
    ],
    units: [
      {
        id: "111af0ec-aa19-48a8-8128-21c40d8c1a14",
        leader: false,
        name: "D: Knight > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            invuln: 5,
            keywords: ["TITANIC", "VEHICLE"],
            modelCount: 1,
            save: 3,
            toughness: 8,
            wounds: 24,
            id: "5554b977-08c1-4e2c-ac99-2ac8ba424726",
            name: "D: Knight > Unit 1 > Model type 1",
            weapons: [],
            ignore: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [],
  },
  {
    name: "D: T4, W2, 3+, 5++, x20",
    computed_keywords: [],
    computed_leaders: [],
    computed_model_count: 20,
    computed_roles: ["Defender"],
    computed_toughness: 4,
    computed_wounds: 2,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "06bdddbd-713d-4367-8517-4605a564162c",
        modelTypeName: null,
        unitId: "9d5d2640-3dfe-41fb-868d-155f771aaac4",
      },
    ],
    units: [
      {
        id: "9d5d2640-3dfe-41fb-868d-155f771aaac4",
        leader: false,
        name: "D: T4, W2, 3+, 5++, x20 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            invuln: 5,
            modelCount: 20,
            save: 3,
            toughness: 4,
            wounds: 2,
            id: "06bdddbd-713d-4367-8517-4605a564162c",
            name: "D: T4, W2, 3+, 5++, x20 > Unit 1 > Model type 1",
            weapons: [],
            ignore: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [],
  },
  {
    name: "D: T4, W2, 4+, 5+++, x20",
    computed_keywords: [],
    computed_leaders: [],
    computed_model_count: 20,
    computed_roles: ["Defender"],
    computed_toughness: 4,
    computed_wounds: 2,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "8108d712-1df3-4487-bbbf-40a8891e9fd8",
        modelTypeName: null,
        unitId: "ec4e611b-e4b9-43a8-8cc6-ca1764848081",
      },
    ],
    units: [
      {
        id: "ec4e611b-e4b9-43a8-8cc6-ca1764848081",
        leader: false,
        name: "D: T4, W2, 4+, 5+++, x20 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            ignore: 5,
            modelCount: 20,
            save: 4,
            toughness: 4,
            wounds: 2,
            id: "8108d712-1df3-4487-bbbf-40a8891e9fd8",
            name: "D: T4, W2, 4+, 5+++, x20 > Unit 1 > Model type 1",
            weapons: [],
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [],
  },
  {
    name: "D: T4, W2, 3+, x10",
    computed_keywords: [],
    computed_leaders: [],
    computed_model_count: 10,
    computed_roles: ["Defender"],
    computed_toughness: 4,
    computed_wounds: 2,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "9dc04047-efcb-4aed-879c-5a17a3a1a23e",
        modelTypeName: null,
        unitId: "020fc265-49d1-4a0a-9639-ab8ebdec7656",
      },
    ],
    units: [
      {
        id: "020fc265-49d1-4a0a-9639-ab8ebdec7656",
        leader: false,
        name: "D: T4, W2, 3+, x10 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            modelCount: 10,
            save: 3,
            toughness: 4,
            wounds: 2,
            id: "9dc04047-efcb-4aed-879c-5a17a3a1a23e",
            name: "D: T4, W2, 3+, x10 > Unit 1 > Model type 1",
            weapons: [],
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [],
  },
  {
    name: "D: T4, W2, 2+, x10",
    computed_keywords: [],
    computed_leaders: [],
    computed_model_count: 10,
    computed_roles: ["Defender"],
    computed_toughness: 4,
    computed_wounds: 2,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "fa22ef99-f14c-4aca-ab1f-6120580e198c",
        modelTypeName: null,
        unitId: "f2a10bfb-a23f-4dd3-8f0d-1e7632190f80",
      },
    ],
    units: [
      {
        id: "f2a10bfb-a23f-4dd3-8f0d-1e7632190f80",
        leader: false,
        name: "D: T4, W2, 2+, x10 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            modelCount: 10,
            save: 2,
            toughness: 4,
            wounds: 2,
            id: "fa22ef99-f14c-4aca-ab1f-6120580e198c",
            name: "D: T4, W2, 2+, x10 > Unit 1 > Model type 1",
            weapons: [],
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [],
  },
  {
    name: "D: T4, W2, 3+, x5",
    computed_keywords: [],
    computed_leaders: [],
    computed_model_count: 5,
    computed_roles: ["Defender"],
    computed_toughness: 5,
    computed_wounds: 3,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "287e54d3-0873-4166-81fa-329e7bae02e5",
        modelTypeName: null,
        unitId: "0b66ac88-9974-45a1-ac1e-796155b7863c",
      },
    ],
    units: [
      {
        id: "0b66ac88-9974-45a1-ac1e-796155b7863c",
        leader: false,
        name: "D: T4, W2, 3+, x5 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            modelCount: 5,
            save: 3,
            toughness: 5,
            wounds: 3,
            id: "287e54d3-0873-4166-81fa-329e7bae02e5",
            name: "D: T4, W2, 3+, x5 > Unit 1 > Model type 1",
            weapons: [],
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [],
  },
  {
    name: "D: T3, W1, 4+, x5",
    computed_keywords: [],
    computed_leaders: [],
    computed_model_count: 5,
    computed_roles: ["Defender"],
    computed_toughness: 3,
    computed_wounds: 1,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "b5156d20-3121-4526-9634-8030251a469a",
        modelTypeName: null,
        unitId: "3d6b4ef8-7c7b-4b1d-8768-a03a92fd4430",
      },
    ],
    units: [
      {
        id: "3d6b4ef8-7c7b-4b1d-8768-a03a92fd4430",
        leader: false,
        name: "D: T3, W1, 4+, x5 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            modelCount: 5,
            save: 4,
            toughness: 3,
            wounds: 1,
            id: "b5156d20-3121-4526-9634-8030251a469a",
            name: "D: T3, W1, 4+, x5 > Unit 1 > Model type 1",
            weapons: [],
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [],
  },
  {
    name: "D: T4, W2, 4+, x20",
    computed_keywords: [],
    computed_leaders: [],
    computed_model_count: 20,
    computed_points: 160,
    computed_roles: ["Defender"],
    computed_toughness: 4,
    computed_wounds: 2,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "ad7ccbb5-252c-4d71-9352-5255076adaab",
        modelTypeName: null,
        unitId: "34061330-1413-45d6-94b2-2cfd8c005416",
      },
    ],
    units: [
      {
        id: "34061330-1413-45d6-94b2-2cfd8c005416",
        leader: false,
        name: "D: T4, W2, 4+, x20 > Unit 1",
        points: 160,
        abilities: [],
        model_types: [
          {
            modelCount: 20,
            save: 4,
            toughness: 4,
            wounds: 2,
            id: "ad7ccbb5-252c-4d71-9352-5255076adaab",
            name: "D: T4, W2, 4+, x20 > Unit 1 > Model type 1",
            weapons: [],
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [],
  },
  {
    name: "D: T4, W2, 4+, 4++, x20",
    computed_keywords: [],
    computed_leaders: [],
    computed_model_count: 20,
    computed_roles: ["Defender"],
    computed_toughness: 4,
    computed_wounds: 2,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "3e94626f-12dd-4fdd-9e31-c3c7622dbb87",
        modelTypeName: null,
        unitId: "6c49f11d-6c3e-472f-8c51-3edd947e0d1f",
      },
    ],
    units: [
      {
        id: "6c49f11d-6c3e-472f-8c51-3edd947e0d1f",
        leader: false,
        name: "D: T4, W2, 4+, 4++, x20 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            invuln: 4,
            modelCount: 20,
            save: 4,
            toughness: 4,
            wounds: 2,
            id: "3e94626f-12dd-4fdd-9e31-c3c7622dbb87",
            name: "D: T4, W2, 4+, 4++, x20 > Unit 1 > Model type 1",
            weapons: [],
            ignore: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [],
  },
  {
    name: "D: Monster equivalent of light vehicle",
    computed_keywords: [],
    computed_leaders: [],
    computed_model_count: 1,
    computed_roles: ["Defender"],
    computed_toughness: 6,
    computed_wounds: 6,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "d98fa1cb-5fec-4e67-ae9e-70e750874fde",
        modelTypeName: null,
        unitId: "d915d71d-d43a-49cb-a0a9-e9a4273c04fb",
      },
    ],
    units: [
      {
        id: "d915d71d-d43a-49cb-a0a9-e9a4273c04fb",
        leader: false,
        name: "D: Monster equivalent of light vehicle > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            modelCount: 1,
            save: 4,
            toughness: 6,
            wounds: 6,
            id: "d98fa1cb-5fec-4e67-ae9e-70e750874fde",
            name: "D: Monster equivalent of light vehicle > Unit 1 > Model type 1",
            weapons: [],
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [],
  },
  {
    name: "D: Regular vehicle",
    computed_keywords: ["VEHICLE"],
    computed_leaders: [],
    computed_model_count: 1,
    computed_points: 160,
    computed_roles: ["Defender"],
    computed_toughness: 7,
    computed_wounds: 10,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "1a810d9d-b0b6-4858-9667-33ac3a3940c4",
        modelTypeName: null,
        unitId: "aaa1ed4e-713c-4682-91a1-d3631e88bf7e",
      },
    ],
    units: [
      {
        id: "aaa1ed4e-713c-4682-91a1-d3631e88bf7e",
        leader: false,
        name: "D: Regular vehicle > Unit 1",
        points: 160,
        abilities: [],
        model_types: [
          {
            keywords: ["VEHICLE"],
            modelCount: 1,
            save: 3,
            toughness: 7,
            wounds: 10,
            id: "1a810d9d-b0b6-4858-9667-33ac3a3940c4",
            name: "D: Regular vehicle > Unit 1 > Model type 1",
            weapons: [],
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [],
  },
  {
    name: "D: Monster equivalent of regular vehicle",
    computed_keywords: [],
    computed_leaders: [],
    computed_model_count: 1,
    computed_roles: ["Defender"],
    computed_toughness: 7,
    computed_wounds: 10,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "cada9a35-ad94-4c10-9817-5960f0c8b69a",
        modelTypeName: null,
        unitId: "ecfef759-53e5-4e45-a077-f8cf1d2be7d6",
      },
    ],
    units: [
      {
        id: "ecfef759-53e5-4e45-a077-f8cf1d2be7d6",
        leader: false,
        name: "D: Monster equivalent of regular vehicle > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            modelCount: 1,
            save: 3,
            toughness: 7,
            wounds: 10,
            id: "cada9a35-ad94-4c10-9817-5960f0c8b69a",
            name: "D: Monster equivalent of regular vehicle > Unit 1 > Model type 1",
            weapons: [],
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [],
  },
  {
    name: "D: Vehicle with FLY",
    computed_keywords: ["FLY", "VEHICLE"],
    computed_leaders: [],
    computed_model_count: 1,
    computed_roles: ["Defender"],
    computed_toughness: 7,
    computed_wounds: 10,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "672f009e-a063-459c-b3d3-ecb817799b0c",
        modelTypeName: null,
        unitId: "4c45c27f-c2a5-4958-9054-9753a435b95e",
      },
    ],
    units: [
      {
        id: "4c45c27f-c2a5-4958-9054-9753a435b95e",
        leader: false,
        name: "D: Vehicle with FLY > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            keywords: ["FLY", "VEHICLE"],
            modelCount: 1,
            save: 3,
            toughness: 7,
            wounds: 10,
            id: "672f009e-a063-459c-b3d3-ecb817799b0c",
            name: "D: Vehicle with FLY > Unit 1 > Model type 1",
            weapons: [],
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [],
  },
  {
    name: "D: Vehicle with AIRCRAFT",
    computed_keywords: ["AIRCRAFT", "FLY", "VEHICLE"],
    computed_leaders: [],
    computed_model_count: 1,
    computed_roles: ["Defender"],
    computed_toughness: 7,
    computed_wounds: 10,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "ddb29587-e7db-422d-9a78-ca76365929b1",
        modelTypeName: null,
        unitId: "a3acc364-0754-4bed-af7c-3b357ccfa9a2",
      },
    ],
    units: [
      {
        id: "a3acc364-0754-4bed-af7c-3b357ccfa9a2",
        leader: false,
        name: "D: Vehicle with AIRCRAFT > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            keywords: ["AIRCRAFT", "FLY", "VEHICLE"],
            modelCount: 1,
            save: 3,
            toughness: 7,
            wounds: 10,
            id: "ddb29587-e7db-422d-9a78-ca76365929b1",
            name: "D: Vehicle with AIRCRAFT > Unit 1 > Model type 1",
            weapons: [],
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [],
  },
  {
    name: "D: T3, W1, 6+, 5++, 5+++ x20",
    computed_keywords: [],
    computed_leaders: [],
    computed_model_count: 20,
    computed_roles: ["Defender"],
    computed_toughness: 3,
    computed_wounds: 1,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "0bd01399-1c21-4f9f-92a4-dafe8d6aea14",
        modelTypeName: null,
        unitId: "5f9d7c98-4c86-4d1a-bb06-a41bf7238ff5",
      },
    ],
    units: [
      {
        id: "5f9d7c98-4c86-4d1a-bb06-a41bf7238ff5",
        leader: false,
        name: "D: T3, W1, 6+, 5++, 5+++ x20 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            ignore: 5,
            invuln: 5,
            modelCount: 20,
            save: 6,
            toughness: 3,
            wounds: 1,
            id: "0bd01399-1c21-4f9f-92a4-dafe8d6aea14",
            name: "D: T3, W1, 6+, 5++, 5+++ x20 > Unit 1 > Model type 1",
            weapons: [],
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [],
  },
  {
    name: "D: T3, W3, 6+, x20",
    computed_keywords: [],
    computed_leaders: [],
    computed_model_count: 20,
    computed_roles: ["Defender"],
    computed_toughness: 3,
    computed_wounds: 3,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "a4b80d1b-0727-462f-a980-25b17294513a",
        modelTypeName: null,
        unitId: "c6f5ea31-c167-4cb4-b29c-3e33b74cd8a4",
      },
    ],
    units: [
      {
        id: "c6f5ea31-c167-4cb4-b29c-3e33b74cd8a4",
        leader: false,
        name: "D: T3, W3, 6+, x20 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            modelCount: 20,
            save: 6,
            toughness: 3,
            wounds: 3,
            id: "a4b80d1b-0727-462f-a980-25b17294513a",
            name: "D: T3, W3, 6+, x20 > Unit 1 > Model type 1",
            weapons: [],
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [],
  },
  {
    name: "D: T4, W1, 6+, 3++, x20",
    computed_keywords: [],
    computed_leaders: [],
    computed_model_count: 20,
    computed_roles: ["Defender"],
    computed_toughness: 4,
    computed_wounds: 1,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "2c910e24-d889-4047-b43e-bfffab3eba91",
        modelTypeName: null,
        unitId: "a774751c-e32e-4a52-844f-18425de71e78",
      },
    ],
    units: [
      {
        id: "a774751c-e32e-4a52-844f-18425de71e78",
        leader: false,
        name: "D: T4, W1, 6+, 3++, x20 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            invuln: 3,
            modelCount: 20,
            save: 6,
            toughness: 4,
            wounds: 1,
            id: "2c910e24-d889-4047-b43e-bfffab3eba91",
            name: "D: T4, W1, 6+, 3++, x20 > Unit 1 > Model type 1",
            weapons: [],
            ignore: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [],
  },
  {
    name: "D: T8, W14, 3+, x1",
    computed_keywords: [],
    computed_leaders: [],
    computed_model_count: 1,
    computed_roles: ["Defender"],
    computed_toughness: 8,
    computed_wounds: 14,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "727ab874-083d-4b1e-b463-fe7e1f79fad1",
        modelTypeName: null,
        unitId: "27f4aa51-9618-41ff-ba23-0481526aed10",
      },
    ],
    units: [
      {
        id: "27f4aa51-9618-41ff-ba23-0481526aed10",
        leader: false,
        name: "D: T8, W14, 3+, x1 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            modelCount: 1,
            save: 3,
            toughness: 8,
            wounds: 14,
            id: "727ab874-083d-4b1e-b463-fe7e1f79fad1",
            name: "D: T8, W14, 3+, x1 > Unit 1 > Model type 1",
            weapons: [],
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [],
  },
  {
    name: "D: T3, W1, 7+, x10",
    computed_keywords: [],
    computed_leaders: [],
    computed_model_count: 10,
    computed_points: 150,
    computed_roles: ["Defender"],
    computed_toughness: 3,
    computed_wounds: 1,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "8a1afa3d-face-4fc8-8235-8cad85a2e90a",
        modelTypeName: null,
        unitId: "b274e51e-843e-436e-af08-0bc282a825ae",
      },
    ],
    units: [
      {
        id: "b274e51e-843e-436e-af08-0bc282a825ae",
        leader: false,
        name: "D: T3, W1, 7+, x10 > Unit 1",
        points: 150,
        abilities: [],
        model_types: [
          {
            modelCount: 10,
            save: 7,
            toughness: 3,
            wounds: 1,
            id: "8a1afa3d-face-4fc8-8235-8cad85a2e90a",
            name: "D: T3, W1, 7+, x10 > Unit 1 > Model type 1",
            weapons: [],
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [],
  },
  {
    name: "D: T7, W3, 3+, INFANTRY, x6",
    computed_keywords: ["INFANTRY"],
    computed_leaders: [],
    computed_model_count: 6,
    computed_points: null,
    computed_roles: ["Defender"],
    computed_toughness: 7,
    computed_wounds: 3,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "e9b4e445-5fc5-4e5b-a860-8861d7e03f6f",
        modelTypeName: null,
        unitId: "a2137fa8-7c49-4c4a-a9df-db5fbe43f794",
      },
    ],
    units: [
      {
        abilities: [],
        id: "a2137fa8-7c49-4c4a-a9df-db5fbe43f794",
        leader: false,
        name: "D: T7, W3, 3+, INFANTRY, x6 > Unit 1",
        points: null,
        model_types: [
          {
            bs: null,
            ignore: null,
            invuln: null,
            keywords: ["INFANTRY"],
            modelCount: 6,
            save: 3,
            toughness: 7,
            weapons: [],
            wounds: 3,
            ws: null,
            id: "e9b4e445-5fc5-4e5b-a860-8861d7e03f6f",
            name: "D: T7, W3, 3+, INFANTRY, x6 > Unit 1 > Model type 1",
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [],
  },
]
